(() => {
  const source = document.getElementById('pristine-purchase-data');
  if (!source) return;
  const data = JSON.parse(source.textContent);
  const registered = new WeakSet();
  const setText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  const setHidden = (node, hidden) => { if (node.hidden !== hidden) node.hidden = hidden; };
  function setup(scope = document) {
    const widgets = scope.matches?.('.hearth-sub') ? [scope] : scope.querySelectorAll?.('.hearth-sub') || [];
    widgets.forEach(widget => {
      if (registered.has(widget) || widget.dataset.productId !== String(data.productId)) return;
      const form = widget.closest('form');
      const section = widget.closest('.shopify-section');
      const variantData = widget.querySelector('[data-variants]');
      if (!form || !section || !variantData) return;
      const plans = JSON.parse(variantData.textContent);
      registered.add(widget);
      const observer = new MutationObserver(schedule);
      const watch = () => observer.observe(widget, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','hidden','data-ready','selected']});
      let queued = false;
      function schedule() { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; update(); }); } }
      function update() {
        observer.disconnect();
        const id = form.querySelector('[name="id"]')?.value || plans.selected;
        const variant = data.variants[id];
        const active = widget.dataset.ready === '1' && !widget.hidden && widget.style.display !== 'none' && variant;
        section.querySelectorAll('.product__price').forEach(el => el.classList.toggle('pristine-price-in-widget', Boolean(active)));
        section.querySelectorAll('.pristine-purchase-summary').forEach(el => el.remove());
        if (!active) { watch(); return; }
        const once = widget.querySelector('[data-once-price]');
        const sub = widget.querySelector('[data-sub-price]');
        const compareAt = variant.compare > variant.price ? variant.compare : 0;
        const selectedPlan = widget.querySelector('[data-plan]')?.value;
        const plan = plans.variants[id]?.plans?.[selectedPlan];
        if (once) {
          let compare = widget.querySelector('[data-pristine-once-compare]');
          if (!compare) { compare = document.createElement('s'); compare.className = 'hearth-sub__was'; compare.setAttribute('data-pristine-once-compare',''); once.before(compare); }
          setText(compare, compareAt ? variant.compareFormatted : ''); setHidden(compare, !compareAt);
          let saving = widget.querySelector('[data-pristine-once-saving]');
          if (!saving) { saving = document.createElement('span'); saving.className = 'hearth-sub__badge pristine-once-saving'; saving.setAttribute('data-pristine-once-saving',''); widget.querySelector('[data-option="once"] .hearth-sub__label').append(saving); }
          setText(saving, compareAt ? data.save.replace('__amount__', Math.round((compareAt - variant.price) / compareAt * 100) + '%') : ''); setHidden(saving, !compareAt);
        }
        const compare = widget.querySelector('[data-compare]');
        if (compare) { setText(compare, compareAt ? variant.compareFormatted : ''); setHidden(compare, !compareAt); }
        if (sub && plan) {
          let delivery = widget.querySelector('[data-pristine-per-delivery]');
          if (!delivery) {
            delivery = document.createElement('span');
            delivery.className = 'pristine-per-delivery';
            delivery.setAttribute('data-pristine-per-delivery', '');
            sub.after(delivery);
          }
          setText(delivery, data.perDelivery);
        }
        const badge = widget.querySelector('[data-save]');
        if (badge && plan && sub) {
          const baseline = compareAt || variant.price;
          const percent = baseline > plan.price ? Math.round((baseline - plan.price) / baseline * 100) : 0;
          setText(badge, percent ? data.save.replace('__amount__', percent + '%') : ''); setHidden(badge, !percent);
        }
        watch();
      }
      form.addEventListener('change', schedule);
      update();
    });
  }
  setup();
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) setup(node);
  }))).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

